// import React, { useState } from "react";
// import API from "./axiosInstance";
// import { useNavigate } from "react-router-dom";

// function ForgotPassword() {
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const navigate = useNavigate();

//   // STEP 1 – Send OTP
//   const sendOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await API.post("/auth/forgot-password", { email });
//       alert(res.data.message);
//       setStep(2);
//     } catch {
//       alert("Email not found ❌");
//     }
//   };

//   // STEP 2 – Verify OTP
//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await API.post("/auth/verify-otp", { email, otp });
//       alert(res.data.message);
//       setStep(3);
//     } catch {
//       alert("Invalid OTP ❌");
//     }
//   };

//   // STEP 3 – Reset Password
//   const resetPassword = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       alert("Passwords do not match ❌");
//       return;
//     }

//     try {
//       const res = await API.post("/auth/reset-password", {
//         email,
//         otp,
//         newPassword: password,
//         confirmPassword,
//       });

//       alert(res.data.message);
//       navigate("/login");
//     } catch (err) {
//       alert(err.response?.data?.message || "Password reset failed ❌");
//     }
//   };

//   return (
//     <div className="auth-container">
//       <h2>🔑 Forgot Password</h2>

//       {step === 1 && (
//         <form onSubmit={sendOtp}>
//           <input
//             type="email"
//             placeholder="Enter registered email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//           <button type="submit">Send OTP</button>
//         </form>
//       )}

//       {step === 2 && (
//         <form onSubmit={verifyOtp}>
//           <input
//             type="text"
//             placeholder="Enter OTP"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             required
//           />
//           <button type="submit">Verify OTP</button>
//         </form>
//       )}

//       {step === 3 && (
//         <form onSubmit={resetPassword}>
//           <input
//             type="password"
//             placeholder="New Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />

//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             required
//           />

//           <button type="submit">Reset Password</button>
//         </form>
//       )}
//     </div>
//   );
// }

// export default ForgotPassword;
import React, { useState } from "react";
import API from "./axiosInstance";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  // STEP 1 – Send OTP
  const sendOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/forgot-password", { email });
      alert(res.data.message);
      setStep(2);
    } catch {
      alert("Email not found ❌");
    }
  };

  // STEP 2 – Verify OTP
  const verifyOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/verify-otp", { email, otp });
      alert(res.data.message);
      setStep(3);
    } catch {
      alert("Invalid OTP ❌");
    }
  };

  // STEP 3 – Reset Password
  const resetPassword = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match ❌");
      return;
    }

    try {
      const res = await API.post("/auth/reset-password", {
        email,
        otp,
        newPassword: password,
        confirmPassword,
      });

      alert(res.data.message);
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.message || "Password reset failed ❌");
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <h2>
          {step === 1 && "Forgot Password 🔑"}
          {step === 2 && "Verify OTP 🔐"}
          {step === 3 && "Reset Password 🔄"}
        </h2>

        <p className="subtitle">
          {step === 1 && "Enter your registered email"}
          {step === 2 && `OTP sent to ${email}`}
          {step === 3 && "Create a new secure password"}
        </p>

        {/* STEP 1 */}
        {step === 1 && (
          <form onSubmit={sendOtp}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Send OTP</button>
          </form>
        )}

        {/* STEP 2 */}
        {step === 2 && (
          <form onSubmit={verifyOtp}>
            <input
              type="text"
              placeholder="Enter 6 digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
              maxLength="6"
              className="otp-input"
            />
            <button type="submit">Verify OTP</button>
          </form>
        )}

        {/* STEP 3 */}
        {step === 3 && (
          <form onSubmit={resetPassword}>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />

            <button type="submit">Reset Password</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
